import { fontFamily } from '@ardoq/design-tokens';
import { canvasLabelMeasurer } from '@ardoq/graph-labeling';

// 2 * 16px padding horizontally + gap + Advanced button + gutter
const BASE_COLUMN_HEADER_WIDTH = 2 * 16 + 16 + 90 + 8;

// Font: weight 500, size 14px, standard line height
const HEADER_FONT = `500 14px/18px ${fontFamily.regular}`;
const measureText = canvasLabelMeasurer(HEADER_FONT);

export const getHeaderTextWidth = (text: string): number => {
  const measured = measureText(text);
  return isNaN(measured)
    ? BASE_COLUMN_HEADER_WIDTH
    : measured + BASE_COLUMN_HEADER_WIDTH;
};
